const ourTeamBio = {
    settings: {},
    init: function() {
        const $ourTeamBio = jQuery('.our-team-bio');

        if( $ourTeamBio.length === 0 ) return;

        this.ourTeamBioHandler();
        this.alignContentTopHeights();

        const debouncedSetEqualHeight = this.debounce(this.alignContentTopHeights, 200);
        window.addEventListener('resize', debouncedSetEqualHeight);
    },
    ourTeamBioHandler: function() {
        const readMoreBtns = jQuery('.our-team-bio__read-bio-btn');

        readMoreBtns.on('click', function (e) {
            jQuery(this).toggleClass('collapsed');
            jQuery(this).next('.our-team-bio__card-bio').slideToggle(400);
        });
    },
    alignContentTopHeights: function() {
        const bioCards = document.querySelectorAll('.our-team-bio__card-content-top');
        let maxHeight = 0;

        bioCards.forEach(card => {
            const cardHeight = card.clientHeight;
            maxHeight = Math.max(maxHeight, cardHeight);
        });

        bioCards.forEach(card => {
            card.style.height = maxHeight + 'px';
        });
    },
    debounce: function(func, delay) {
        let timeoutId;
        return () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(func, delay);
        };
    }
}

export default ourTeamBio;